export default __webpack_public_path__ + "static/media/forbes.83895001.png";